function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { DecimalColumnFormatter } from '@deephaven/jsapi-utils';
import FormatContextMenuUtils from "./FormatContextMenuUtils.js";
class DecimalFormatContextMenu {
  /**
   * Creates list of formatting options for Decimal context menu
   * @param dh JSAPI instance
   * @param selectedFormat Selected format object, null for no selected format
   * @param onCustomFormatChange Callback to call when the custom format is changed
   * @returns Array of formatting options for the context menu
   */
  static getOptions(dh, selectedFormat, onCustomFormatChange) {
    var formatItems = [{
      format: DecimalColumnFormatter.FORMAT_PERCENT,
      group: DecimalFormatContextMenu.presetGroup
    }, {
      format: DecimalColumnFormatter.FORMAT_BASIS_POINTS,
      group: DecimalFormatContextMenu.presetGroup
    }, {
      format: DecimalColumnFormatter.FORMAT_THOUSANDS,
      group: DecimalFormatContextMenu.presetGroup
    }, {
      format: DecimalColumnFormatter.FORMAT_MILLIONS,
      group: DecimalFormatContextMenu.presetGroup
    }, {
      format: DecimalColumnFormatter.FORMAT_SCIENTIFIC_NOTATION,
      group: DecimalFormatContextMenu.presetGroup
    }, {
      format: DecimalColumnFormatter.FORMAT_ROUND,
      group: DecimalFormatContextMenu.presetRoundGroup
    }, {
      format: DecimalColumnFormatter.FORMAT_ROUND_TWO_DECIMALS,
      group: DecimalFormatContextMenu.presetRoundGroup
    }, {
      format: DecimalColumnFormatter.FORMAT_ROUND_FOUR_DECIMALS,
      group: DecimalFormatContextMenu.presetRoundGroup
    }];
    var defaultFormatOption = FormatContextMenuUtils.makeOption('Default', null, DecimalFormatContextMenu.defaultGroup, FormatContextMenuUtils.isDefaultSelected(selectedFormat));
    var presetFormatOptions = formatItems.map(item => FormatContextMenuUtils.makeOption(item.format.label, item.format, item.group, DecimalColumnFormatter.isSameFormat(item.format, selectedFormat)));
    var isCustomSelected = FormatContextMenuUtils.isCustomSelected(selectedFormat);
    var customFormat = isCustomSelected ? selectedFormat : DecimalColumnFormatter.makeCustomFormat();
    var customFormatOption = FormatContextMenuUtils.makeCustomFormatOption(customFormat, DecimalFormatContextMenu.customGroup, DecimalColumnFormatter.DEFAULT_FORMAT_STRING, isCustomSelected, formatString => {
      if (formatString != null) {
        var newCustomFormat = DecimalColumnFormatter.makeCustomFormat(formatString);
        if (DecimalColumnFormatter.isValid(dh, newCustomFormat)) {
          onCustomFormatChange(newCustomFormat);
        }
      } else {
        onCustomFormatChange(null);
      }
    });
    return [defaultFormatOption, ...presetFormatOptions, customFormatOption];
  }
}
_defineProperty(DecimalFormatContextMenu, "defaultGroup", 10);
_defineProperty(DecimalFormatContextMenu, "presetGroup", 20);
_defineProperty(DecimalFormatContextMenu, "presetRoundGroup", 30);
_defineProperty(DecimalFormatContextMenu, "customGroup", 40);
export default DecimalFormatContextMenu;
//# sourceMappingURL=DecimalFormatContextMenu.js.map